import { Pagination } from '@/Types/api/response';

import { LicensesEnum } from './LicensesEnum';

type DeviceValueColor = 'red' | 'amber' | 'yellow' | 'green';

export enum DeviceChambersState {
    CONSTANT = 'constant',
    FLICKERING = 'flickering',
}

export enum NotificationStatus {
    SUCCESS = 'success',
    WARNING = 'warning',
    CRITICAL = 'critical',
}

interface DeviceLicenseDataResource {
    license: LicensesEnum | null;
    started_at: string | null;
    ended_at: string | null;
    representation: string | null;
}

interface DeviceChambersFullnessResource {
    pct: number;
    color: DeviceValueColor;
    state: DeviceChambersState;
}

interface DeviceBatteryLevelResource {
    pct: number | null;
    color: DeviceValueColor;
}

export interface DeviceMonitoringResource {
    id: number;
    identifier: string | null;
    station_name: string | null;
    type: number;
    mac_address: string;
    has_unread_notifications: boolean;
    is_firmware_update_available: boolean;
    is_powered_on: boolean;
    license: DeviceLicenseDataResource;
    chambers_fullness: DeviceChambersFullnessResource;
    battery_level: DeviceBatteryLevelResource;
}

export interface StationMonitoringResource {
    id: number;
    name: string;
    app_version: string;
    app_version_build: string;
    is_app_update_available: boolean;
    devices: DeviceMonitoringResource[];
}

export interface NotificationResource {
    id: number;
    content: string;
    status: NotificationStatus;
    description: string | null;
    is_read: boolean;
    created_at: string | null;
}

export type StationsResponse = {
    stations: {
        pagination: Pagination;
        items: StationMonitoringResource[];
    };
};

export type GetStationResponse = {
    station: StationMonitoringResource;
};

export type GetDeviceResponse = {
    device: DeviceMonitoringResource;
};

export type NotificationsResponse = {
    notifications: {
        pagination: Pagination;
        items: NotificationResource[];
    };
};

export type GetNotificationsBadgesResponse = {
    monitoring_stations: number;
};
